
import { CirclePercent } from "lucide-react";
import { Habit } from "@/types/habit";

interface ProgressIndicatorProps {
  habits: Habit[];
}

export const ProgressIndicator = ({ habits }: ProgressIndicatorProps) => {
  const totalDaysAll = habits.reduce((acc, habit) => acc + habit.totalDays, 0);
  const completedDaysAll = habits.reduce(
    (acc, habit) => acc + habit.completedDays,
    0
  );
  const totalProgress = totalDaysAll > 0 ? (completedDaysAll / totalDaysAll) * 100 : 0;

  return (
    <div className="flex flex-col items-center mt-5">
      <div className="relative w-24 h-24">
        <CirclePercent className="w-24 h-24 text-gray-200" strokeWidth={2} />
        <div
          className="absolute inset-0 flex items-center justify-center"
          style={{
            background: `conic-gradient(#9b87f5 ${totalProgress}%, transparent ${totalProgress}%)`,
            borderRadius: "50%",
          }}
        >
          <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center">
            <span className="text-xl font-semibold text-primary">
              {Math.round(totalProgress)}%
            </span>
          </div>
        </div>
      </div>
      <span className="text-sm text-gray-600 mt-2">Overall Progress</span>
    </div>
  );
};
